import { SHOW_NOTIFICATION, DISMISS_NOTIFICATION } from "../actionTypes";

export const showNotification = (message, type = "error") => ({
  type: SHOW_NOTIFICATION,
  payload: { message, type },
});

export const dismissNotification = () => ({
  type: DISMISS_NOTIFICATION,
});
